import { render, staticRenderFns } from "./VOrb.vue?vue&type=template&id=67a0af60&scoped=true&"
import script from "./VOrb.vue?vue&type=script&lang=js&"
export * from "./VOrb.vue?vue&type=script&lang=js&"
import style0 from "./VOrb.vue?vue&type=style&index=0&id=67a0af60&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a0af60",
  null
  
)

export default component.exports